import React, { useEffect, useState } from "react";
import { DashboardLayout } from "@/components/Layout/DashboardLayout";
import api from "@/lib/api";
import { adminNavItems } from "./_nav";
import { useLang } from "@/contexts/LanguageContext";
import { useCurrency } from "@/contexts/CurrencyContext";

const ROLES = ["all", "customer", "restaurant_owner", "rider", "admin"];

export default function AdminUsers() {
  const { t } = useLang();
  const { formatPrice } = useCurrency();
  const [users, setUsers] = useState([]);
  const [filter, setFilter] = useState("all");

  const load = () => {
    const params = filter === "all" ? {} : { role: filter };
    api.get("/admin/users", { params }).then(r => setUsers(r.data));
  };
  useEffect(() => { load(); }, [filter]);

  return (
    <DashboardLayout items={adminNavItems(t)} title={t("users")}>
      <div className="mb-4 flex flex-wrap gap-2">
        {ROLES.map(r => (
          <button key={r} onClick={() => setFilter(r)} data-testid={`filter-${r}`} className={`px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider border ${filter === r ? "bg-[var(--so-orange)] text-white border-[var(--so-orange)]" : "border-[var(--so-border)] text-[var(--so-text-soft)]"}`}>
            {r}
          </button>
        ))}
      </div>
      <div className="so-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[var(--so-bg)] text-xs uppercase tracking-wider text-[var(--so-text-soft)]">
            <tr><th className="text-start p-3">Name</th><th className="text-start p-3">Email</th><th className="text-start p-3">Role</th><th className="text-start p-3">Wallet</th><th className="text-start p-3">Joined</th></tr>
          </thead>
          <tbody>
            {users.map(u => (
              <tr key={u.id} className="border-t border-[var(--so-border)]" data-testid={`user-${u.id}`}>
                <td className="p-3 font-semibold">{u.name}</td>
                <td className="p-3 text-[var(--so-text-soft)]">{u.email}</td>
                <td className="p-3"><span className="text-[10px] font-bold uppercase px-2 py-0.5 rounded-full bg-[var(--so-orange)]/10 text-[var(--so-orange)]">{u.role}</span></td>
                <td className="p-3">{formatPrice(u.wallet_balance)}</td>
                <td className="p-3 text-[var(--so-text-soft)] text-xs">{new Date(u.created_at).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </DashboardLayout>
  );
}
